/* @flow */
export type Platform = "desktop" | "mac_desktop" | "mobile" | "default";
export type Currency =
  | "EUR"
  | "HKD"
  | "RUB"
  | "THB"
  | "USD"
  | "VND"
  | "default";

type ByPlatform<Value> = {
  [platform: Platform]: Value
};

type ByCurrency<Value> = {
  [currency: Currency]: Value
};

export type Bank =
  | {
      "data-code": string,
      img_path: string,
      title_code: string
    }
  | {
      "data-code": string,
      img_path: string,
      img_type: "sprite",
      width: number,
      height: number,
      background_position: string,
      title_code: string
    };

export type PaymentPoint = {
  "data-code": string,
  img_path: string,
  title_code: string
};

type LegacyBanksSettings = {
  forBilling: string,
  banks: Array<Bank> | ByCurrency<Array<Bank>>
};

type BankOptions = {
  mustBeSelected: 0 | 1,
  "choose.bank.key": string,
  showTitle?: boolean,
  banks: Array<Bank> | ByCurrency<Array<Bank>>
};

type PaymentPointOptions = {
  payment_points: ByCurrency<Array<PaymentPoint>>
};

export type BanksSettings =
  | LegacyBanksSettings
  | {
      [billing: string]: BankOptions | PaymentPointOptions
    };

type PaymentImage = {
  path: string
};

type TypeImage = {
  path: string
};

export type Billing = {
  allowedCurrencies: Array<Currency>,
  allowedPlatforms: Array<Platform>,
  bonus: number,
  id: string,
  inputValue: string,
  needsFullName?: boolean,
  needsPhoneNumber?: boolean,
  paymentImages: ByCurrency<Array<PaymentImage>>,
  typeImage: TypeImage,
  is_scratch?: boolean,
  providers?: Object,
  min_amount?: ByCurrency<number>,
  title: string,
  tooltip?: string
};

export type Deposit = {
  amount: number,
  bonus: number,
  compensationsCount: number,
  compensationsAmount: number,
  vip: 0 | 1
};

export type Config = {
  banksSettings: BanksSettings | 0,
  billings: { [key: string]: Billing },
  defaultBilling: ByPlatform<string>,
  defaultValue: ByCurrency<number>,
  defaults: {
    billingType: string,
    bank?: string
  },
  deposits: ByPlatform<ByCurrency<Array<Deposit>>>
};

// TODO: Унести эти функции куда-нибудь

export function getByPlatform<Value>(
  platform: Platform,
  input: ByPlatform<Value>
): Value {
  return input.hasOwnProperty(platform) ? input[platform] : input["default"];
}

export function getByCurrency<Value>(
  currency: Currency,
  input: ByCurrency<Value>
): Value {
  return input.hasOwnProperty(currency) ? input[currency] : input["default"];
}



// WEBPACK FOOTER //
// ./src/configs/FillupConfigTypes.js